module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/core-js/modules/_a-function.js
// module id = ../../../../core-js/modules/_a-function.js
// module chunks = 3